import { render, staticRenderFns } from "./VConfirm.vue?vue&type=template&id=505865cb"
import script from "./VConfirm.vue?vue&type=script&lang=js"
export * from "./VConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('505865cb')) {
      api.createRecord('505865cb', component.options)
    } else {
      api.reload('505865cb', component.options)
    }
    module.hot.accept("./VConfirm.vue?vue&type=template&id=505865cb", function () {
      api.rerender('505865cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VDialog/VConfirm.vue"
export default component.exports